export interface GoodsReceiptNoteRow {
  id: number
  code: string
  reference: string
  warehouse: string
  vendor: string
  orderCode: string
  date: string
  total: number
  status: string
  /** When true, GRN is already converted to a bill — hide convert / exclude from combined bill. */
  isBillCreated: boolean
}

export type GrnLine = {
  id: number
  itemId: string
  batchId: string
  /** From API on edit — used if GetBatches omits this batch id */
  batchLabel?: string
  orderQuantity: number
  quantityReceived: number
  toReceive: number
  unitPrice: number
  taxRateId: string
  taxPercent: number
  discountPercent: number
}

export const newGrnLine = (): GrnLine => ({
  id: 0,
  itemId: '',
  batchId: '',
  batchLabel: undefined,
  orderQuantity: 0,
  quantityReceived: 0,
  toReceive: 0,
  unitPrice: 0,
  taxRateId: '',
  taxPercent: 0,
  discountPercent: 0,
})

